import { LevelIndicatorBars, type LevelIndicatorLevel } from "@/components/ui/LevelIndicatorBars";
import { CourseSkillLevel } from "@/lib/constants";
import React from "react";
import { SizableText, XStack } from "tamagui";

const TITLE = "#0D0D0D" as const;

const LEVEL_BAR_ACTIVE = "#E17100";
const LEVEL_BAR_INACTIVE = "#C9C5C3";

function skillLevelToBars(level: CourseSkillLevel): LevelIndicatorLevel {
  if (level === CourseSkillLevel.Beginner) return 1;
  if (level === CourseSkillLevel.Intermediate) return 2;
  return 3;
}

function skillLevelBadgeLabel(level: CourseSkillLevel): string {
  switch (level) {
    case CourseSkillLevel.Beginner:
      return "Beginner";
    case CourseSkillLevel.Intermediate:
      return "Intermediate";
    case CourseSkillLevel.Advanced:
      return "Advanced";
    default:
      return "";
  }
}

export function CourseSkillLevelBadge({
  level,
  showLabel,
  backgroundColor = "#FFFFFF",
}: {
  level: CourseSkillLevel;
  showLabel: boolean;
  /** Override pill bg — e.g. page cream on white hero cards */
  backgroundColor?: string;
}) {
  const bars = skillLevelToBars(level);
  const label = skillLevelBadgeLabel(level);
  const compact = !showLabel;

  return (
    <XStack
      ai="center"
      jc="center"
      flexShrink={0}
      backgroundColor={backgroundColor}
      borderRadius={6}
      py={compact ? 3 : 4}
      px={compact ? 8 : 12}
      height={compact ? 22 : 28}
      gap={showLabel ? 7 : 0}
    >
      <LevelIndicatorBars
        level={bars}
        activeColor={LEVEL_BAR_ACTIVE}
        inactiveColor={LEVEL_BAR_INACTIVE}
        size={compact ? 14 : 18}
      />
      {showLabel ? (
        <SizableText
          ff="$body"
          color={TITLE}
          fontWeight="600"
          fontSize={16}
          lineHeight={20}
          letterSpacing={0}
          textTransform="capitalize"
          numberOfLines={1}
        >
          {label}
        </SizableText>
      ) : null}
    </XStack>
  );
}
